var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"will-upload-progress"},[_c('v-progress-circular',{staticClass:"mr-3",attrs:{"indeterminate":"","color":"primary","size":22,"width":3}}),_vm._v(" "),_c('span',{staticClass:"will-upload-progress-text"},[_vm._v(_vm._s(_vm.message))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }